import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import Header from "@/components/Header";
import ProtectedRoute from "@/components/ProtectedRoute";
import VisitorTracker from "@/components/VisitorTracker";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Calculator from "@/pages/Calculator";
import AnalyseDetail from "@/pages/AnalyseDetail";
import Documents from "@/pages/Documents";
import Reports from "@/pages/Reports";
import Judgment from "@/pages/Judgment";
import Profile from "@/pages/Profile";
import PublicDVC from "@/pages/PublicDVC";
import Observatory from "@/pages/Observatory";
import ObservatoryReport from "@/pages/ObservatoryReport";
import ObservatoryCompare from "@/pages/ObservatoryCompare";
import ObservatoryDashboard from "@/pages/ObservatoryDashboard";
import ObservatoryData from "@/pages/ObservatoryData";
import Scenarios from "@/pages/Scenarios";
import ArgumentaireDetail from "@/pages/ArgumentaireDetail";
import Apprentissage from "@/pages/Apprentissage";
import Quiz from "@/pages/Quiz";
import GlossairePublic from "@/pages/GlossairePublic";
import AdminLogin from "@/pages/AdminLogin";
import AdminReset from "@/pages/AdminReset";
import AdminLayout from "@/pages/AdminLayout";
import AdminHome from "@/pages/AdminHome";
import AdminLLM from "@/pages/AdminLLM";
import AdminCMS from "@/pages/AdminCMS";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminSettings from "@/pages/AdminSettings";

function Shell() {
  const { user } = useAuth();
  const path = window.location.pathname;
  const isAdmin = path.startsWith("/admin");
  const hideHeader = path.startsWith("/share/") || path === "/auth" || path === "/glossaire-public" || isAdmin;
  return (
    <>
      <VisitorTracker />
      {user && !hideHeader && <Header />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/calculator" element={<ProtectedRoute><Calculator /></ProtectedRoute>} />
        <Route path="/analyses/:id" element={<ProtectedRoute><AnalyseDetail /></ProtectedRoute>} />
        <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/reports/:id" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/judgment" element={<ProtectedRoute><Judgment /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/observatory" element={<ProtectedRoute><Observatory /></ProtectedRoute>} />
        <Route path="/observatory/dashboard" element={<ProtectedRoute><ObservatoryDashboard /></ProtectedRoute>} />
        <Route path="/observatory/data" element={<ProtectedRoute><ObservatoryData /></ProtectedRoute>} />
        <Route path="/scenarios" element={<ProtectedRoute><Scenarios /></ProtectedRoute>} />
        <Route path="/scenarios/argumentaires/:id" element={<ProtectedRoute><ArgumentaireDetail /></ProtectedRoute>} />
        <Route path="/apprentissage" element={<ProtectedRoute><Apprentissage /></ProtectedRoute>} />
        <Route path="/apprentissage/quiz/:id" element={<ProtectedRoute><Quiz /></ProtectedRoute>} />
        <Route path="/glossaire-public" element={<GlossairePublic />} />
        <Route path="/observatory/reports/:id" element={<ProtectedRoute><ObservatoryReport /></ProtectedRoute>} />
        <Route path="/observatory/compare/:id" element={<ProtectedRoute><ObservatoryCompare /></ProtectedRoute>} />
        <Route path="/share/dvc/:token" element={<PublicDVC />} />

        {/* ===== Admin console ===== */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/reset" element={<AdminReset />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminHome />} />
          <Route path="llm" element={<AdminLLM />} />
          <Route path="cms" element={<AdminCMS />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AdminAuthProvider>
            <Shell />
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  background: "#0F1115",
                  color: "#FDFBF7",
                  border: "1px solid #0F1115",
                  borderRadius: 0,
                  fontFamily: "IBM Plex Mono, monospace",
                  fontSize: "12px",
                  letterSpacing: "0.05em",
                },
              }}
            />
          </AdminAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
